module.exports = __webpack_public_path__ + "images/merge/big.png";